var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        {
          attrs: {
            required: _vm.required,
            label: "建物",
            "label-width": _vm.labelWidth,
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: _vm.gutter } },
            [
              _c(
                "el-col",
                { staticClass: "col_positon", attrs: { span: _vm.localSpan1 } },
                [
                  _c(
                    "el-form-item",
                    {
                      ref: "elFormItem",
                      attrs: { prop: _vm.prop, rules: _vm.rules },
                      scopedSlots: _vm._u([
                        {
                          key: "error",
                          fn: function (ref) {
                            var error = ref.error
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: error,
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item__error" },
                                    [_vm._v(_vm._s(error))]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("el-input", {
                        staticClass: "left_input",
                        class: [_vm.showList ? "multiple" : ""],
                        attrs: { disabled: _vm.showList || _vm.localDisabled },
                        on: {
                          input: _vm.handleLocalInputVal,
                          blur: _vm.handleBuildingBlur,
                        },
                        model: {
                          value: _vm.localBlgscd,
                          callback: function ($$v) {
                            _vm.localBlgscd = $$v
                          },
                          expression: "localBlgscd",
                        },
                      }),
                      !_vm.localDisabled
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "more_box flex_center flex_center_align",
                              on: { click: _vm.selectDep },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "select" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.localSpan2 } },
                [
                  _c(
                    "el-select",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBldgcd,
                          expression: "showBldgcd",
                        },
                      ],
                      staticClass: "middle_input",
                      attrs: {
                        placeholder: "棟",
                        clearable: _vm.multiSelect,
                        disabled: _vm.localDisabled,
                      },
                      on: { change: _vm.selectionChanged },
                      model: {
                        value: _vm.localBldgcd,
                        callback: function ($$v) {
                          _vm.localBldgcd = $$v
                        },
                        expression: "localBldgcd",
                      },
                    },
                    _vm._l(_vm.bldgcdList, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.bldgcd,
                          attrs: { label: item.bldgcd, value: item.bldgcd },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(item.bldgcd)),
                          ]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-left": "20px",
                                "font-size": "13px",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.blgsbldgkj) + " ")]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.localSpan3 } },
                [
                  _c("el-input", {
                    staticClass: "right_input",
                    class: [_vm.showList ? "multiple" : ""],
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.localBlgsnmkj,
                      callback: function ($$v) {
                        _vm.localBlgsnmkj = $$v
                      },
                      expression: "localBlgsnmkj",
                    },
                  }),
                  _c(
                    "el-popover",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showDetailBtn,
                          expression: "showDetailBtn",
                        },
                      ],
                      attrs: { placement: "bottom", trigger: "click" },
                    },
                    [
                      _c(
                        "el-table",
                        { attrs: { data: _vm.list, border: "", stripe: "" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              width: "80",
                              property: "blgscd",
                              label: "建物CD",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              width: "120",
                              property: "blgsnmkj",
                              label: "建物名",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "more_box flex_center flex_center_align more_change_box",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "inner_box flex_center flex_center_align",
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "sel" },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("build-dialog", {
        attrs: { visible: _vm.dialogVisible, "multi-select": _vm.multiSelect },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          "get-selection": _vm.getSelection,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }